import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState, useTransition } from 'react';
import { RouteGlobalProvider, RouteLevelProvider } from './context.js';
import { Outlet } from './Outlet.js';
import { useOnLocationChange } from './hooks.js';
const Root = () => _jsx(Outlet, {});
export function Router({ children, routes, onNavigate }) {
    const rootRoute = useMemo(() => ({
        path: '',
        children: routes,
        component: Root,
    }), [routes]);
    const root = useMemo(() => ({
        path: '',
        params: {},
        route: rootRoute,
    }), [rootRoute]);
    const [path, setPath] = useState(() => window.location.pathname);
    const [transitioning, startTransition] = useTransition();
    useOnLocationChange((location, state) => {
        const cancelNavigation = (onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(location.pathname, state)) === false;
        if (cancelNavigation)
            return;
        if (state === null || state === void 0 ? void 0 : state.skipTransition) {
            setPath(location.pathname);
        }
        else {
            startTransition(() => {
                setPath(location.pathname);
            });
        }
    });
    return (_jsx(RouteGlobalProvider, Object.assign({ rootMatch: root, path: path, transitioning: transitioning }, { children: _jsx(RouteLevelProvider, Object.assign({ subpath: '', match: root }, { children: children })) })));
}
//# sourceMappingURL=Router.js.map